import { render, staticRenderFns, recyclableRender, components } from "./deposit-pay.vue?vue&type=template&id=ddcfb6e2&"
var renderjs
import script from "./deposit-pay.vue?vue&type=script&lang=js&"
export * from "./deposit-pay.vue?vue&type=script&lang=js&"
import style0 from "./deposit-pay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/deposit-pay.vue"
export default component.exports